export default __webpack_public_path__ + "static/media/info.ba347ef9.svg";